import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { banners, comics } from "@/mocks/comics";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((current) => (current + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const go = (next: number) => {
    setIndex((next + banners.length) % banners.length);
  };

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden bg-background-950">
      {banners.map((banner, i) => {
        const comic = comics.find((item) => item.id === banner.comicId);
        return (
          <div
            key={banner.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <img
              src={banner.image}
              alt={`${banner.title} 焦点推荐`}
              title={`${banner.title} JMcomic2 高清漫画在线阅读`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-950 via-background-950/80 to-background-950/20" />
            <div className="absolute inset-0">
              <div className="w-full h-full px-4 md:px-16 flex flex-col justify-center max-w-3xl">
                <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 mb-4">
                  <i className="ri-fire-fill" />
                  焦点推荐
                </span>
                <h2 className="font-heading font-extrabold text-3xl md:text-5xl text-foreground-950 leading-tight">
                  {banner.title}
                </h2>
                <p className="mt-4 text-sm md:text-base text-foreground-700 max-w-xl leading-relaxed">
                  {banner.subtitle}
                </p>
                {comic && (
                  <div className="mt-4 flex flex-wrap items-center gap-3 text-xs md:text-sm text-foreground-700">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-user-3-line text-primary-400" />
                      {comic.author}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-eye-line text-primary-400" />
                      {(comic.views / 10000).toFixed(1)}万阅读
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-list-check text-primary-400" />
                      共 {comic.chapters.length} 话
                    </span>
                  </div>
                )}
                <div className="mt-7 flex flex-wrap items-center gap-3">
                  <Link
                    to={`/detail/${banner.comicId}`}
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-book-open-line" />
                    立即阅读
                  </Link>
                  <Link
                    to="/category"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100/80 border border-background-300 text-foreground-950 font-medium text-sm hover:border-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-compass-3-line" />
                    发现更多
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <button
        type="button"
        onClick={() => go(index - 1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 rounded-full bg-background-950/60 text-foreground-950 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        type="button"
        onClick={() => go(index + 1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 rounded-full bg-background-950/60 text-foreground-950 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((banner, i) => (
          <button
            key={banner.id}
            type="button"
            onClick={() => go(i)}
            aria-label={`切换到第 ${i + 1} 张`}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? "w-8 bg-primary-500" : "w-3 bg-foreground-700/60 hover:bg-foreground-600"
            }`}
          />
        ))}
      </div>
    </section>
  );
}